import { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import type { RQLError } from "../lib/rql";
import { ALLOWED_FIELD_NAMES } from "../lib/rql";

interface RQLQueryInputProps {
  query: string;
  onChange: (query: string) => void;
  error?: RQLError | null;
  placeholder?: string;
  className?: string;
  showLabel?: boolean;
}

const RQLQueryInput = ({
  query,
  onChange,
  error,
  placeholder = "unsettled_cash_total > 10000 and num_trades > 30",
  className = "mb-2",
  showLabel = true,
}: RQLQueryInputProps) => {
  const [focused, setFocused] = useState(false);

  const showFieldHints = focused && query.length === 0;

  return (
    <div className={className}>
      {showLabel ? (
        <InputGroup>
          <InputGroup.Text>RQL</InputGroup.Text>
          <Form.Control
            type="text"
            value={query}
            onChange={(e) => onChange(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder={placeholder}
            isInvalid={!!error}
            aria-label="RQL Query"
          />
        </InputGroup>
      ) : (
        <Form.Control
          type="text"
          value={query}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          isInvalid={!!error}
          aria-label="RQL Query"
          size="sm"
        />
      )}

      {error && showLabel && (
        <Form.Text className="text-danger d-block mt-1">
          {error.message}
          {error.position !== undefined && (
            <span className="ms-1 text-muted">
              (at position {error.position})
            </span>
          )}
        </Form.Text>
      )}

      {showFieldHints && (
        <Form.Text className="text-muted d-block mt-1">
          <strong>Available fields:</strong> {ALLOWED_FIELD_NAMES.join(", ")}
          <br />
          <strong>Example:</strong> {placeholder}
        </Form.Text>
      )}
    </div>
  );
};

export default RQLQueryInput;
